var $ = require('jquery');
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
var matchHeight = require("jquery-match-height");

const carousels = global.carousels;

$(function() {
    calcDescHeight();
    $('.dynamic-tabs').each(function() {
        stickyTabNav();
        let _this = $(this);
        let tabs = _this.find('.dynamic-tabs__tab-container');

        resizeCarousels($(this).find('.dynamic-tabs__content[data-content-num="1"]'));

        tabs.on('click', function() {
            tabClick(_this, $(this), true)
        })
            
        $(window).on('scroll', function() {
            stickyTabNav();
        })
    })
})

$(window).on('load', function() {
    calcDescHeight();
    scrollToAndSelectTab();
})

$(window).on('resize', function() {
    calcDescHeight();
});

function tabClick(parent, el, scrollTo) {
    let tabNum = el.attr('data-tab-num');
    let newActiveContent = parent.find('.dynamic-tabs__content[data-content-num="' + tabNum + '"]');

    parent.attr('data-active-tab', tabNum);

    parent.find('.dynamic-tabs__tab-container.active').removeClass('active');
    parent.find('.dynamic-tabs__content.active').removeClass('active');
    parent.find('.dynamic-tabs__tab-description.animate').removeClass('animate');

    el.addClass('active');

    el.find('.dynamic-tabs__tab-description').css('width', el.attr('data-tab-desc-width'));

    setTimeout(() => {
        el.find('.dynamic-tabs__tab-description').addClass('animate');
    }, 10)

    newActiveContent.addClass('active');
    el.parent().attr('data-tab-color', tabNum);

    setTimeout(() => {
        calcDescHeight();
    }, 450);

    resizeCarousels(newActiveContent);

    if (scrollTo == true ) {
        $('html, body').animate({
            scrollTop: parent.position().top - ($(window).width() > 768 ? 125 : 0 ),
        })
    }
}

function calcDescHeight(){
    let currentHeight = 0;
    let activeDescription = $('.dynamic-tabs__tab-container.active').find('.dynamic-tabs__tab-description');
    if ( activeDescription.length && activeDescription[0].scrollHeight > currentHeight ) {
        currentHeight = activeDescription[0].scrollHeight;
        activeDescription.css("max-height", currentHeight);
    }
}

function stickyTabNav() {
    let headerHeight = parseFloat(getComputedStyle(document.querySelector(':root')).getPropertyValue('--header-height'));
    let alertHeight = parseFloat(getComputedStyle(document.querySelector(':root')).getPropertyValue('--alert-height'));
    // let tabsPos = $('.container__dynamic-tabs')[0].getBoundingClientRect().top;
    let tabsPos = $('.container__dynamic-tabs').offset().top - $(window).scrollTop();

    tabsPos < headerHeight + alertHeight ? $('.container__dynamic-tabs').addClass('is-sticky') : $('.container__dynamic-tabs').removeClass('is-sticky');
}

function checkIfTabHasACarousel(content) {
    return content.find('.carousel').length ? true : false;    
}

function resizeCarousels(newActiveContent) {
    if ( checkIfTabHasACarousel(newActiveContent) ) {

        $(carousels).each(function() {
            let _this = $(this);
            let cards = $(this).find('.carousel-cards__card .carousel-cards__card-wrapper');

            setTimeout(function() {
                _this.find('.carousel-cards__content').matchHeight();

                if ( !_this.hasClass('tabs-and-content__tabs') && _this.hasClass('carousel') ) {
                    _this.flickity('resize');
                } else if ( _this.hasClass('tabs-and-content__tabs') && $(window).width() <= 768 ) {
                    _this.flickity('resize');
                }


                ScrollTrigger.refresh();
            }, 500);

            fadeIn(_this, cards, true);
        })
    }
}

function fadeIn( parent, elements, stagger ) {
    if ( elements.length && parent.length ) {
        let items = elements;
        let _this = parent;
        gsap.to(items, {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: _this,
                start: 'top 80%',
            },
            stagger: stagger ? 0.2 : false, 
            duration: 0.7,
        })
    }   
}

function scrollToAndSelectTab() {
    var url = window.location.search;
    var urlParams = new URLSearchParams(url);

    if ( urlParams.get('tab') !== null ) {

        let tab = $('.dynamic-tabs__tab-container[data-tab-num="'+urlParams.get('tab')+'"]');
        let scrollTo = window.location.hash == '#tabs' ? true : false;

        tabClick(tab.closest('.dynamic-tabs'), $('.dynamic-tabs__tab-container[data-tab-num="'+urlParams.get('tab')+'"]'), scrollTo);
    }
}